/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_FooterInputs */

const en_pricing_footer = /** @type {(inputs: Pricing_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All prices in EUR. Prices are final prices -- no VAT charged (Section 19 UStG). Powered by Stripe. Cancel anytime.`)
};

const de_pricing_footer = /** @type {(inputs: Pricing_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Preise in EUR. Endpreise -- keine MwSt. erhoben (SS 19 UStG). Powered by Stripe. Jederzeit kuendbar.`)
};

const fr_pricing_footer = /** @type {(inputs: Pricing_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tous les prix en EUR. Prix finaux -- pas de TVA facturee (SS 19 UStG). Propulse par Stripe. Annule a tout moment.`)
};

const es_pricing_footer = /** @type {(inputs: Pricing_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos los precios en EUR. Precios finales -- no se cobra IVA (SS 19 UStG). Procesado por Stripe. Cancele en cualquier momento.`)
};

const it_pricing_footer = /** @type {(inputs: Pricing_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutti i prezzi in EUR. Prezzi finali -- nessuna IVA addebitata (SS 19 UStG). Supportato da Stripe. Annulla in qualsiasi momento.`)
};

const nl_pricing_footer = /** @type {(inputs: Pricing_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle prijzen in EUR. Eindprijzen -- geen BTW in rekening gebracht (SS 19 UStG). Aangedreven door Stripe. Annuleer wanneer je wilt.`)
};

const pl_pricing_footer = /** @type {(inputs: Pricing_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wszystkie ceny w EUR. Ceny koncowe -- VAT nie jest naliczany (SS 19 UStG). Zasilane przez Stripe. Anuluj w dowolnym momencie.`)
};

const fi_pricing_footer = /** @type {(inputs: Pricing_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kaikki hinnat EUR. Loppuhinnat -- ALV:a ei peritae (SS 19 UStG). Toimittanut Stripe. Peruuta milloin tahansa.`)
};

const da_pricing_footer = /** @type {(inputs: Pricing_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle priser i EUR. Slutpriser — ingen moms opkræves (§ 19 UStG). Drives af Stripe. Opsig når som helst.`)
};

const sv_pricing_footer = /** @type {(inputs: Pricing_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alla priser i EUR. Slutpriser -- ingen moms debiteras (SS 19 UStG). Drivs av Stripe. Avbryt när som helst.`)
};

/**
* | output |
* | --- |
* | "All prices in EUR. Prices are final prices -- no VAT charged (Section 19 UStG). Powered by Stripe. Cancel anytime." |
*
* @param {Pricing_FooterInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_footer = /** @type {((inputs?: Pricing_FooterInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_FooterInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_footer(inputs)
	if (locale === "fr") return fr_pricing_footer(inputs)
	if (locale === "es") return es_pricing_footer(inputs)
	if (locale === "it") return it_pricing_footer(inputs)
	if (locale === "nl") return nl_pricing_footer(inputs)
	if (locale === "pl") return pl_pricing_footer(inputs)
	if (locale === "fi") return fi_pricing_footer(inputs)
	if (locale === "da") return da_pricing_footer(inputs)
	if (locale === "sv") return sv_pricing_footer(inputs)
	return en_pricing_footer(inputs)
});